export function roundToCents(num) {
    return Math.round((num + Number.EPSILON) * 100) / 100;
}
const formatPrice = (amount, opts) => {
    const prefix = opts?.prefix ?? "";
    const centsOption = opts?.cents ?? "hideIfZero";
    let result = roundToCents(amount / 100).toLocaleString("en-Us");
    let [dollars, cents] = result.split(".");
    if (cents === undefined) {
        cents = "00";
    }
    if (cents.length === 1) {
        cents += "0";
    }
    if (centsOption === "alwaysShow") {
        result = `${dollars}.${cents}`;
    }
    else if (centsOption === "alwaysHide") {
        result = dollars;
    }
    else if (centsOption === "hideIfZero" && cents === "00") {
        result = dollars;
    }
    else {
        result = `${dollars}.${cents}`;
    }
    if (result.startsWith("-")) {
        result = result.replace("-", "-" + prefix);
    }
    else {
        result = prefix + result;
    }
    return result;
};
export const applyDiscountPercent = (amount, discount) => {
    return roundToCents(amount - amount * (discount / 100));
};
export const modifiersToIntervals = (modifiers, includeBaseInterval = false) => {
    const modifierIntervals = [];
    if (includeBaseInterval) {
        modifierIntervals.push({
            min_quantity: 1,
            max_quantity: undefined,
            discount_flat_amount: undefined,
            discount_percent: undefined,
        });
    }
    for (const modifier of modifiers) {
        const previousModifier = modifierIntervals.at(-1);
        if (previousModifier != null) {
            previousModifier.max_quantity = modifier.min_quantity - 1;
        }
        modifierIntervals.push({
            ...modifier,
            max_quantity: undefined,
        });
    }
    return modifierIntervals;
};
export const calculatePricePerItem = (basePricePerItem, discount) => {
    if (discount?.discount_percent) {
        return applyDiscountPercent(basePricePerItem, discount.discount_percent);
    }
    else if (discount?.discount_flat_amount) {
        return basePricePerItem - discount.discount_flat_amount;
    }
    return basePricePerItem;
};
export const findPriceModifier = (modifiers, quantity) => {
    let selectedModifier = undefined;
    for (const modifier of modifiers) {
        if (modifier.min_quantity <= quantity) {
            selectedModifier = modifier;
        }
    }
    return selectedModifier;
};
export const centsToDollars = (amount) => {
    return roundToCents(amount / 100);
};
export const dollarsToCents = (amount) => {
    return Math.round(amount * 100);
};
export default formatPrice;
//# sourceMappingURL=formatPrice.js.map